import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceCreateDiet(params) {
  return await formDataRequest("dietitian/create", params);
}

export async function serviceUpdateDiet(params) {
  return await formDataRequest("dietitian/update", params);
}

export async function serviceDeleteDiet(params) {
  return await postRequest("dietitian/delete", params);
}

export async function serviceGetDiet(params) {
  return await postRequest("dietitian", params);
}

export async function serviceGetDietDetails(params) {
  return await postRequest("dietitian/detail", params);
}
export async function serviceUpdateDietPriority(params) {
  return await postRequest("dietitian/update/priority", params);
}
export async function serviceDietIsExist(params) {
  return await postRequest("dietitian/update/priority", params);
}
